__turbopack_context__.v({
  "biometric-switch": "KDcjla_biometric-switch",
  "login-password-form": "KDcjla_login-password-form",
  "login-password-form__content": "KDcjla_login-password-form__content",
  "login-password-form__content--reduce-spacing": "KDcjla_login-password-form__content--reduce-spacing",
  "login-password-form__fieldset": "KDcjla_login-password-form__fieldset",
  "login-password-form__footer": "KDcjla_login-password-form__footer",
  "login-password-form__heading": "KDcjla_login-password-form__heading",
  "login-password-form__legend": "KDcjla_login-password-form__legend",
  "login-password-form__reset-password-button": "KDcjla_login-password-form__reset-password-button",
  "login-password-form__separator": "KDcjla_login-password-form__separator",
  "login-password-form__sub-heading": "KDcjla_login-password-form__sub-heading",
});
